function removeYmmOnlyEntries(terms) {
	return terms.filter((vehicle) => {
		return (
			(vehicle.year !== null &&
				vehicle.year !== undefined &&
				vehicle.year !== "") ||
			(vehicle.make !== null &&
				vehicle.make !== undefined &&
				vehicle.make !== "") ||
			(vehicle.model !== null &&
				vehicle.model !== undefined &&
				vehicle.model !== "")
		);
	});
}

document.addEventListener("DOMContentLoaded", function () {
	const searchTerms = JSON.parse(localStorage.getItem("searchTerms") || "[]");
	const cleanedTerms = removeYmmOnlyEntries(searchTerms);

	// Only proceed if cleanup actually removes something
	if (cleanedTerms.length < searchTerms.length) {
		localStorage.setItem("searchTerms", JSON.stringify(cleanedTerms));

		// Only reload ONCE
		if (localStorage.getItem("removedOldGarageData") !== "true") {
			localStorage.setItem("removedOldGarageData", "true");
			setTimeout(function () {
				// Skip the reload when the submodel gate is active, the URL
				// still carries ?fitment=, and the cleaned vehicle already has
				// a submodel. The migration cleanup already ran (localStorage
				// updated above) — no reload needed; fitment card reads
				// localStorage directly.
				const _params = new URLSearchParams(window.location.search);
				const _terms = JSON.parse(localStorage.getItem("searchTerms") || "[]");
				const _hasSub = !!(
					_terms[0] && String(_terms[0].submodel || "").trim()
				);
				if (window.partifySubmodelRequired && _params.has("fitment") && _hasSub)
					return;
				location.reload();
			}, 100);
		}
	}
});
